import isBrowser from "./IsBrowser";

function isSmallScreen(): boolean {
  return isBrowser() && window.innerWidth < 768;
}

export default isSmallScreen;
